import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { DashboardModel, UpcomingEventItem } from '../DashboardModel';
import { DashboardController } from '../DashboardController';
import { Paper } from 'components/paper';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem } from 'utils/Navigation';
import { Icon } from '@material-ui/core';
import { AddVacationScene } from 'scenes/addvacation/view/AddVacationScene';
import { CalendarController as CalendarController } from 'scenes/calendar/CalendarController';
import { UserVacationStatisticsData } from 'data/UserVacationStatisticsData';
import { UpcomingEventsData } from 'data/UpcomingEventsData';

export class DashboardScene extends AScene<{}, DashboardModel, DashboardController> {
    protected createControlller(): DashboardController {
        return new DashboardController();
    }

    public render(): React.ReactNode {
        if (this.model.isInit) {
            return (<div></div>);
        }

        return (
            <div style={{ width: '100%', padding: '64px' }}>
                <Paper title="Vacation statistics">
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                        {this.renderCounter("Annual vacation count", this.model.vacationStatModel.annualVacationCount, "#0ac")}
                        {this.renderCounter("Carried vacation count", this.model.vacationStatModel.carriedVacationCount, "#0277bd")}
                        {this.renderCounter("Used up vacation count", this.model.vacationStatModel.usedUpVacationCount, "#b71c1c")}
                        {this.renderCounter("Remaining vacation count", this.model.vacationStatModel.remainingVacationCount, "#558b2f")}
                    </div>
                </Paper>

                {this.renderUpcomingEvents()}

                <AddVacationScene onVacationAdded={() => {
                    CalendarController.emptyCache();
                    new UserVacationStatisticsData().invalidate();
                    new UpcomingEventsData().invalidate();
                    this.controller.rerender();
                }} />
            </div>
        )
    }

    private renderCounter(title: string, count: string, color: string) {
        return (
            <div style={{ padding: '20px' }}>
                <div style={{ textAlign: 'center', width: '100%', fontSize: '96px', fontWeight: 300, color: color }}>{count}</div>
                <div style={{ textAlign: 'center', width: '100%', fontSize: '14px', fontWeight: 300, color: '#444' }}>{title}</div>
            </div>
        )
    }

    private renderUpcomingEvents() {
        return (
            <Paper title="Upcoming events">
                {this.model.upcomingEventsModel.events.map((item, index) => {
                    return this.renderUpcomingEventsItem(item, index);
                })}
            </Paper>
        );
    }

    private renderUpcomingEventsItem(item: UpcomingEventItem, index: number) {
        return (
            <div key={"uei-" + item.date} style={{ width: '100%' }}>
                <div style={{ display: 'flex', width: '100%', padding: '40px', borderTop: '1px solid #ddd' }}>
                    <Icon style={{ display: 'block', fontSize: '36px', color: item.iconColor }}>{item.icon}</Icon>
                    <div style={{ paddingLeft: '20px' }}>
                        <div style={{ fontSize: '20px', fontWeight: 600, color: '#222' }}>{item.title}</div>
                        <div style={{ fontSize: '16px', fontWeight: 400, color: '#888' }}>{item.description}</div>
                    </div>
                    <div style={{ flex: 1, textAlign: 'right', fontSize: '14px', fontWeight: 500, color: '#bbb' }}>{item.date}</div>
                </div>
            </div>
        );
    }


}

export class DashboardSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return <DashboardScene />
    }

}